import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '@clerk/clerk-react'
import { actionCreators } from '../../store/Auth.ts'
import { setClerkTokenGetter } from '../../utils/clerkToken'

export function ClerkAuthPull() {
    const dispatch = useDispatch()
    const { isLoaded, isSignedIn, getToken } = useAuth()
    const hydrated = useSelector(state => !!state.auth?.hydrated)

    useEffect(() => {
        setClerkTokenGetter(async () => {
            try { return await getToken() } catch { return '' }
        })
    }, [getToken])

    useEffect(() => {
        dispatch(actionCreators.setClerkStatus(isLoaded, !!isSignedIn))
    }, [isLoaded, isSignedIn, dispatch])

    useEffect(() => {
        if (!isLoaded) return
        if (isSignedIn && !hydrated) {
            dispatch(actionCreators.hydrateFromClerk())
        }
        if (!isSignedIn && hydrated) {
            dispatch(actionCreators.logoutUser())
        }
    }, [isLoaded, isSignedIn, hydrated, dispatch])

    return null
}
